import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import './WordGame.scss';
import { img, staticsUrl } from '../../config';

const useStyles = makeStyles(theme => ({
  game: {
    '& button': {
      cursor: 'pointer',
      background: '#fff',
    },
    '& h3': {
      textAlign: 'center',
      marginBottom: '0.5em',
    },
    '& p': {
      textAlign: 'center',
      marginTop: 0,
    },
  },
  gameInner: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  allImages: {
    width: '100%',
    maxWidth: 450,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: 10,
    borderRadius: '2%',
    boxSizing: 'border-box',
    '& > div': {
      width: '32.5%',
      paddingBottom: '32.5%',
      boxSizing: 'border-box',
      borderTop: '1px solid rgba(127, 127, 127, 0.5)',
      borderLeft: '1px solid rgba(127, 127, 127, 0.5)',
      borderRight: '1px solid rgba(0, 0, 0, 0.4)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
      borderRadius: '5%',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      marginBottom: '1%',
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.4)',
      cursor: 'pointer',
      transition: 'all 0.3s',
      backgroundColor: '#fff',
      '&:hover': {
        zIndex: 2,
        transform: 'scale(1.15)',
        boxShadow: '10px 10px 5px rgba(0, 0, 0, 0.1)',
      },
      '&:active': {
        zIndex: 2,
        transform: 'scale(1.15)',
        boxShadow: '10px 10px 5px rgba(0, 0, 0, 0.1)',
      },
    }
  },
  action: {
    textAlign: 'center',
    marginTop: 20,
  },
}));

const cardBackground = `url("${img('word-game-card-back.jpg')}")`;
const availTime = 30;
let currentWord = 0;
let wordsQueue = [];
let failed = [];
let testStatus = 'intro';
let timerTimeout = 0;
let counter = 0;
let failCount = 0;
let timeout1 = 0;
let timeout2 = 0;
let timeout3 = 0;
let time = 0;
function WordGame(props) {
  const classes = useStyles();
  const [words, setWords] = useState([]);
  const [text, setText] = useState('Kliknij na obrazek i zapamiętaj skojarzony z nim wyraz');
  const [translation, setTranslation] = useState('Jak bedziesz gotowy/gotowa kliknij na start');
  const [status, setStatus] = useState('intro');
  const { exercise, startStats, finishExercise, action, type } = props.exerciseProps;
  const [timer, setTimer] = useState(0);
  // eslint-disable-next-line
  const refs = new Array(9).fill(null).map(el => useRef(null));

  useEffect(() => {
    startStats(type);
    return () => {
      clearTimeout(timerTimeout);
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const wordsArr = [];
    for (let i = 1; i < 10; ++i) {
      wordsArr.push(exercise['word' + i]);
    }
    setWords(wordsArr);
  }, [exercise]);

  const play = (word) => {
    action();
    word && props.media.play(staticsUrl + word.soundUrl);
  }

  const finishTest = () => {
    finishExercise();
    const learningBonus = Math.max(30 - counter) * 2;
    const playTimeBonus = Math.max(45 - getTime() + time) * 2;
    const penaltyPoints = failCount * 6;
    const points = Math.max(1, 50 + learningBonus + playTimeBonus - penaltyPoints);
    setText(`Zdobytych punktów: ${points}`);
    setTranslation('Spróbuj jeszcze raz lub przejdź do następnego ćwiczenia');
    if (!failCount) props.media.finish();
    setStatus('finished');
    testStatus = 'finished';
  };

  const clickedFail = (idx) => {
    props.media.failure();
    testStatus = 'waiting';
    failCount++;
    showCard(idx);
    const failedTwice = failed.indexOf(currentWord) !== -1;
    timeout1 = setTimeout(() => {
      if (failedTwice) {
        timeout2 = setTimeout(() => {
          testStatus = 'test';
          hideCard(idx);
          showCard(currentWord);
          next();
        }, 1000);
      } else {
        failed.push(currentWord);
        testStatus = 'waiting'
        timeout3 = setTimeout(() => {
          testStatus = 'test';
          hideCard(idx);
        }, 1000);
      }
    }, 1000);
  }

  const clickedOk = (idx) => {
    props.media.success();
    showCard(idx);
    next();
  }

  const onCardClick = (word, idx) => {
    action();
    if (idx !== currentWord && wordsQueue.indexOf(idx) === -1 && testStatus !== 'finished') return;
    if (testStatus === 'test') {
      const correct = idx === currentWord;
      if (correct) {
        clickedOk(idx);
      } else {
        clickedFail(idx);
      }
    } else if (testStatus === 'intro' || testStatus === 'finished') {
      setText(word ? word.text : '???');
      setTranslation(word ? word.translation : '???');
      word && play(word);
    }
  }

  const showCard = idx => {
    if (!refs[idx]?.current) return;
    refs[idx].current.classList.add("active");
  }

  const hideCard = idx => {
    if (!refs[idx]?.current) return;
    refs[idx].current.classList.remove("active");
  }

  const drawflippingCard = (word, idx) => {
    const imgUrl = word ? `url("${staticsUrl + word.imageUrl}")` : '';
    return (
      <div className='wg-flip-card-inner' onClick={() => onCardClick(word, idx)}>
        <div className='wg-flip-card-front'>
          <div style={{ backgroundImage: cardBackground }}></div>
        </div>
        <div className='wg-flip-card-back'>
          <div style={{ backgroundImage: imgUrl }}></div>
        </div>
      </div>
    );
  }

  const drawTest = () => {
    return (
      <div className="wg-flip-cards">
        {words.map((word, idx) => <div key={idx} ref={refs[idx]} class="wg-flip-card">{drawflippingCard(word, idx)}</div>)}
      </div>
    )
  }

  const showAllCards = () => {
    let idx = 0;
    const loop = () => {
      timeout1 = setTimeout(() => {
        refs[idx].current.classList.add("active");
        idx++;
        if (idx < 9) loop();
      }, 100);
    }
    loop();
  }

  const hideAllCards = () => {
    let idx = 0;
    const loop = () => {
      timeout2 = setTimeout(() => {
        hideCard(idx);
        idx++;
        if (idx < 9) loop();
      }, 100);
    }
    loop();
  }

  const startTest1 = () => {
    action();
    setWords(shuffle(words));
    wordsQueue = shuffle([0, 1, 2, 3, 4, 5, 6, 7, 8]);
    setStatus('test1');
    setTimeout(() => showAllCards(), 500);
    setText('Zapamiętaj położenie obrazków. Masz na to 30 sekund');
    setTranslation('Jeśli będziesz gotowy/gotowa wcześniej kliknij na start');
    setTimer(0);
    counter = 0;
    failCount = 0;
    countDown();
    testStatus = 'intro';
  }

  const startTest2 = () => {
    action();
    hideAllCards();
    testStatus = 'waiting';
    time = getTime();
    failed = [];
    timeout3 = setTimeout(() => {
      testStatus = 'test';
      next();
    }, 1000);
    setStatus('test2');
    clearTimeout(timerTimeout);
  }

  const countDown = () => {
    timerTimeout = setTimeout(() => {
      setTimer(++counter);
      if (counter < availTime) {
        countDown();
      } else {
        startTest2();
      }
    }, 1000);
  }

  const next = () => {
    if (wordsQueue.length === 0) return finishTest();
    currentWord = wordsQueue.pop();
    const word = words[currentWord];
    setText(word ? word.text : '???');
    setTranslation(word ? word.translation : '???');
    play(word);
  }

  const drawIntro = () => {
    const doWord = (word) => {
      setText(word ? word.text : '???');
      setTranslation(word ? word.translation : '???');
      word && play(word);
    }

    return (
      <div className={classes.allImages}>
        {words.map((word, idx) => {
          const imgUrl = word ? `url("${staticsUrl + word.imageUrl}")` : '';
          return (
            <div
              key={idx}
              style={{ backgroundImage: imgUrl }}
              onClick={() => doWord(word)}
            ></div>
          );
        })}
      </div>
    )
  }

  return (
    <div className="container">
      <div className={classes.game}>
        <h3>{text}</h3>
        <p>{translation}</p>
        <div className={classes.gameInner}>
          {(status === 'test1' || status === 'test2' || status === 'finished') && drawTest()}
          {status === 'intro' && drawIntro()}
        </div>
        <div className={classes.action}>
          {status === 'intro' && <Button variant="outlined" color="secondary" onClick={startTest1}>Start</Button>}
          {status === 'test1' && <Button variant="outlined" color="secondary" onClick={startTest2}>{availTime - timer} Start</Button>}
          {status === 'finished' && <Button variant="outlined" color="secondary" onClick={startTest1}>Restart</Button>}
        </div>
      </div>
    </div>
  );
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

const getTime = () => Math.floor(new Date().getTime() / 1000);

export default connect(mapStateToProps)(WordGame);